import { gql } from "@apollo/client";

const WalletQuery = gql`
  query wallet($channel: String!) {
    wallet(channel: $channel) {
      id
      balance
    }
  }
`;

const TransactionsList = gql`
  query TransactionsList($first: Int, $offset: Int, $channel: String!) {
    walletTransactions(first: $first, offset: $offset, channel: $channel) {
      edges {
        node {
          id
          changedAmount
          balance
          type
          reason
          createdAt
          payment {
            gateway
          }
          description
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

const WalletGatewaysList = gql`
  query WalletGatewaysList($channel: String!) {
    chargeWalletAvailableGateways(channel: $channel) {
      id
      name
      logo
    }
  }
`;

const chargeWalletMutation = gql`
  mutation chargeWallet(
    $amount: Decimal!
    $gatewayId: ID!
    $callbackHost: String!
    $channel: String!
  ) {
    chargeWallet(
      amount: $amount
      gatewayId: $gatewayId
      callbackHost: $callbackHost
      channel: $channel
    ) {
      result {
        hasNavigation
        message
        success
        url
      }
    }
  }
`;

export {
  WalletQuery,
  TransactionsList,
  WalletGatewaysList,
  chargeWalletMutation,
};
